import axiosClient from "../../http-common";

class ServiceDeskIssuesApiService {
    getServiceDeskIssues(tenantId, containerId, userId){
        return axiosClient.get(`api/v1/tenants/${tenantId}/containers/${containerId}/users/${userId}/serviceDeskIssues`);
    }
}

export default new ServiceDeskIssuesApiService();